/*
 *
 * UserHeaderBox actions
 *
 */

import {
  GET_USER_WATCHER,
  GET_USER_SUCCESS,
  GET_USER_FAILED,
  LOGOUT_WATCHER,
  UPLOAD_LOGO_WATCHER,
} from "./constants"

export function getUserWatcher() {
  return { type: GET_USER_WATCHER }
}

export function uploadLogoWatcher(payload) {
  return {
    type: UPLOAD_LOGO_WATCHER,
    payload,
  }
}

export function getUserSuccess(payload) {
  return {
    type: GET_USER_SUCCESS,
    payload,
  }
}

export function getUserFailed() {
  return { type: GET_USER_FAILED }
}

export function logoutWatcher() {
  return { type: LOGOUT_WATCHER }
}
